import { gql } from '@apollo/client'

export const ACCOMMODATIONS_QUERY = gql`
  query Accommodations(
    $tenantId: String
    $pmsType: ProviderAdapter
    $providerCode: String
    $channelCode: String
    $showLog: Boolean
  ) {
    accommodations(
      tenantId: $tenantId
      pmsType: $pmsType
      providerCode: $providerCode
      channelCode: $channelCode
      showLog: $showLog
    ) {
      basicDetails {
        name
        nameTranslatedList {
          label
          value
          nativeLabel
        }
        propertyCode
        displayPropertyCode
        accommodationID
        totaRoomNumber
        displayTenantCode
        tenantId
        tenantCode
        tenantName
        city
        cityID
      }
    }
  }
`

export const ACCOMMODATION_QUERY = gql`
  query Accommodation($accommodationId: String, $propertyCode: String!) {
    accommodation(
      accommodationId: $accommodationId
      propertyCode: $propertyCode
    ) {
      basicDetails {
        name
        nameTranslatedList {
          label
          value
          nativeLabel
        }
        propertyCode
        displayTenantCode
        displayPropertyCode
        resourceType
        website
        description
        descriptionTranslatedList {
          label
          value
          nativeLabel
        }
        starClass
        tenantCode
        timeZone
        totaRoomNumber
        accommodationID
        tenantId
        defaultProviderCode
        checkinFrom
        checkinTo
        checkoutFrom
        checkoutTo
      }
      addressDetails {
        country {
          label
          value
          id
          code
        }
        city
        postalCode
        address
        addressTranslatedList {
          label
          value
          nativeLabel
        }
        latitude
        longitude
      }
      contactDetails {
        email
        bookingConfirmationEmail
        bookingFailReportEmail
        bookingConfirmationPhoneNumber
        bookingFailReportPhoneNumber
        fax
        bookingConfirmationFax
      }
      wbsDetails {
        overrideRedirect
        bookingRedirect
      }
      inventoryAndBooking {
        canReserveCombination
        currencies
      }
    }
  }
`

export const ACCOMMODATION_NAME_QUERY = gql`
  query AccommodationName($accommodationId: String, $propertyCode: String) {
    accommodationName(
      accommodationId: $accommodationId
      propertyCode: $propertyCode
    ) {
      name
      propertyCode
    }
  }
`

export const ACCOMMODATION_GENERATE_MUTATION = gql`
  mutation GenerateAccommodation($input: AccommodationInput!) {
    generateAccommodation(input: $input) {
      message
    }
  }
`

export const ACCOMMODATION_MODIFY_MUTATION = gql`
  mutation ModifyAccommodation(
    $input: AccommodationInput!
    $propertyCode: String!
  ) {
    modifyAccommodation(input: $input, propertyCode: $propertyCode) {
      message
    }
  }
`
